<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div v-show="pagetype === 1">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品编号')" prop="id">
                  <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('商品编号')" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品名称')" prop="goodsName">
                  <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('商品名称')" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('SKU编码')" prop="goodsSku">
                  <a-input v-model="queryParam.goodsSku" @pressEnter="handleQuery" :maxLength="64" :placeholder="$t('请输入')+$t('SKU编码')" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品类型')" prop="goodsType">
                  <a-select mode="multiple" :placeholder="$t('请选择')+$t('商品类型')" style="width: 100%" v-model="queryParam.goodsTypeList" allowClear>
                    <a-select-option v-for="(item, index) in (customDict.GoodsTypeEnum || [])" :value="item.type" :key="item.type || index">
                      {{ $t(item.name) }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('商品分类')" prop="categoryId">
                    <a-tree-select v-model="queryParam.categoryId" style="width: 100%"
                                   :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="$t('请选择')+$t('商品分类')"
                                   :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                                   tree-default-expand-all allow-clear>
                    </a-tree-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('商品状态')" prop="status">
                    <a-select :placeholder="$t('请选择')+$t('商品状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                      <a-select-option v-for="(item, index) in (customDict.GoodsOnOffEnum || [])" :value="item.type" :key="item.type || index">
                        {{ $t(item.name) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('标签')" prop="labelList">
                    <a-select mode="multiple" :placeholder="$t('请选择')+$t('标签')" style="width: 100%" v-model="queryParam.labelList" allowClear>
                      <a-select-option v-for="(item, index) in (labelList || [])" :value="item.id+''" :key="item.id || index">
                        {{ $t(item.name) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('是否推荐')" prop="isRecommend">
                    <a-select :placeholder="$t('请选择')+$t('是否推荐')" style="width: 100%" v-model="queryParam.isRecommend" allowClear>
                      <a-select-option v-for="(item, index) in (customDict.TFEnum || [])" :value="item.type"
                                       :key="item.type || index">
                        {{ $t(item.name) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('是否新品')" prop="isNew">
                    <a-select :placeholder="$t('请选择')+$t('是否新品')" style="width: 100%" v-model="queryParam.isNew" allowClear>
                      <a-select-option v-for="(item, index) in (customDict.TFEnum || [])" :value="item.type"
                                       :key="item.type || index">
                        {{ $t(item.name) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('是否限购')" prop="isRestriction">
                    <a-select :placeholder="$t('请选择')+$t('是否限购')" style="width: 100%" v-model="queryParam.isRestriction" allowClear>
                      <a-select-option v-for="(item, index) in (customDict.TFEnum || [])" :value="item.type"
                                       :key="item.type || index">
                        {{ $t(item.name) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('是否显示')" prop="isShowApp">
                    <a-select :placeholder="$t('请选择')+$t('是否显示')" style="width: 100%" v-model="queryParam.isShowApp" allowClear>
                      <a-select-option v-for="(item, index) in (customDict.TFEnum || [])" :value="item.type"
                                       :key="item.type || index">
                        {{ $t(item.name) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <!--是否赠品商品 -->
                <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('是否赠品')" prop="isGift">
                    <a-select :placeholder="$t('请选择')+$t('是否赠品')" style="width: 100%" v-model="queryParam.isGift" allowClear>
                      <a-select-option v-for="(item, index) in (customDict.TFEnum || [])" :value="item.type"
                                       :key="item.type || index">
                        {{ $t(item.name) }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                  <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? $t('收起') : $t('展开') }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="handleAdd()" v-hasPermi="['goods:goods:add']">
            <a-icon type="plus" />
            {{ $t('新增') }}
          </a-button>
          <!--          <a-button type="primary" :disabled="single" @click="handleUpdate(ids)" v-hasPermi="['goods:goods:add']">-->
          <!--            <a-icon type="edit" />-->
          <!--            {{ $t('修改') }}-->
          <!--          </a-button>-->
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['goods:goods:remove']">
            <a-icon type="delete" />
            {{ $t('删除') }}
          </a-button>
          <!--          <a-button type="primary" :disabled="multiple" @click="handleBatchCopy" v-hasPermi="['goods:goods:copy']">-->
          <!--            <a-icon type="copy" />-->
          <!--            {{ $t('批量复制') }}-->
          <!--          </a-button>-->
          <!--          <a-button type="primary" :disabled="multiple" @click="handleOn" v-hasPermi="['goods:goods:batchOn']">-->
          <!--            <a-icon type="check" />-->
          <!--            {{ $t('批量上架') }}-->
          <!--          </a-button>-->
          <!--          <a-button type="danger" :disabled="multiple" @click="handleOff" v-hasPermi="['goods:goods:batchOff']">-->
          <!--            <a-icon type="stop" />-->
          <!--            {{ $t('批量下架') }}-->
          <!--          </a-button>-->
          <!--          <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goods:export']">-->
          <!--            <a-icon type="download" />-->
          <!--            {{ $t('导出') }}-->
          <!--          </a-button>-->
          <a-button type="primary" :disabled="multiple" @click="handleSelectExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />
            {{ $t('选中导出') }}
          </a-button>
          <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />
            {{ $t('导出全部') }}
          </a-button>
          <a-button type="primary" @click="handleImportGoods" v-hasPermi="['goods:goods:add']">
            {{ $t('导入') }}
          </a-button>
          <a-button type="primary" @click="handleBatchUpdatePrice" v-hasPermi="['goods:goods:edit']">
            <a-icon type="edit" />
            {{ $t('批量修改价格') }}
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          :scroll="{ x: '130%', y: tableScrollY }"
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>

          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none" />
            </div>
          </template>
          <span slot="categoryId" slot-scope="text, record">
            {{ getCategoryNameById(record.categoryId) }}
          </span>
          <span slot="brandId" slot-scope="text, record">
             {{ getBrandNameById(record.brandId) }}
          </span>
          <span slot="starId" slot-scope="text, record">
            <a @click="handleJumpStar(record.starId)">{{ record.starName }}</a>
          </span>
          <span slot="stock" slot-scope="text, record">
            <a @click="updateSkuStock(record.id,record.goodsType)">{{ record.stock }}</a>
          </span>
          <span slot="orderCount" slot-scope="text, record">
            <a v-if="hasPermission('goods:goods:rank')" @click="openRank(record)">{{ record.orderCount }}</a>
            <span v-else>{{ record.orderCount }}</span>
          </span>
          <template slot="goodsType" slot-scope="text, record">
            <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType" />
          </template>
          <!--是否赠品商品 -->
          <span slot="isGift" slot-scope="text, record">
            <custom-dict-tag :options="customDict.TFEnum" :value="record.isGift" />
          </span>
          <span slot="status" slot-scope="text, record">
            <a-select style="width: 100%" v-model="record.status" @change="onStatusChange(record)">
              <a-select-option v-for="(item, index) in (customDict.GoodsOnOffEnum || [])" :value="item.type"
                               :key="item.type || index">
                        {{ $t(item.name) }}
              </a-select-option>
            </a-select>
          </span>
          <span slot="operation" slot-scope="text, record">
<!--            <a @click="handleCopyGoodsLink(record)">-->
            <!--               <a-icon type="copy" />{{ $t('复制链接') }}-->
            <!--            </a>-->
            <!--            <br>-->
            <!--            <a @click="handlePreviewGoods(record)">-->
            <!--               <a-icon type="eye" />{{ $t('预览') }}-->
            <!--            </a>-->
            <!--            <a-divider type="vertical" v-hasPermi="['goods:goods:copy']" />-->
            <!--            <a @click="handleCopy(record, undefined)" v-hasPermi="['goods:goods:copy']">-->
            <!--               <a-icon type="copy" />{{ $t('复制') }}-->
            <!--            </a>-->
            <!--            <br>-->
            <a @click="handleUpdate(record, undefined)" v-hasPermi="['goods:goods:edit']">
               <a-icon type="edit" />{{ $t('修改') }}
            </a>
            <a-divider type="vertical" v-hasPermi="['goods:goods:remove']" />
            <a @click="handleDelete(record)" v-hasPermi="['goods:goods:remove']">
              <a-icon type="delete" />{{ $t('删除') }}
            </a>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
      <update-sku-stock ref="updateSkuStock" @ok="getList"></update-sku-stock>
    </a-card>

    <import-excel ref="importExcelRef" />
    <!-- 批量改价弹窗 -->
        <!-- 批量改价弹窗 -->
    <a-modal
      :title="$t('批量修改价格')"
      :visible="batchPriceModalVisible"
      :confirm-loading="batchPriceLoading"
      @ok="handleBatchPriceConfirm"
      @cancel="handleBatchPriceCancel"
      :width="500"
    >
      <a-form-model :model="batchPriceForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-alert
          :message="$t('提示')"
          :description="$t('将根据当前筛选条件修改所有符合条件的商品价格，请谨慎操作！')"
          type="warning"
          show-icon
          style="margin-bottom: 16px;"
        />
        <a-form-model-item :label="$t('修改为价格')" required>
          <a-input-number
            v-model="batchPriceForm.price"
            :min="0"
            :max="999999999"
            :step="0.01"
            :precision="2"
            :placeholder="$t('请输入价格')"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('筛选条件')">
          <div style="color: #999; font-size: 12px; max-height: 200px; overflow-y: auto;">
            <div v-if="queryParam.goodsName">{{ $t('商品名称') }}：{{ queryParam.goodsName }}</div>
            <div v-if="queryParam.id">{{ $t('商品编号') }}：{{ queryParam.id }}</div>
            <div v-if="queryParam.categoryId">{{ $t('分类ID') }}：{{ queryParam.categoryId }}</div>
            <div v-if="queryParam.status !== undefined">{{ $t('状态') }}：{{ queryParam.status }}</div>
            <div v-if="queryParam.isRecommend !== undefined">{{ $t('是否推荐') }}：{{ queryParam.isRecommend }}</div>
            <div v-if="queryParam.isNew !== undefined">{{ $t('是否新品') }}：{{ queryParam.isNew }}</div>
            <div v-if="queryParam.isRestriction !== undefined">{{ $t('是否限购') }}：{{ queryParam.isRestriction }}</div>
            <div v-if="queryParam.isShowApp !== undefined">{{ $t('是否显示') }}：{{ queryParam.isShowApp }}</div>
            <div v-if="queryParam.goodsTypeList && queryParam.goodsTypeList.length > 0">
              {{ $t('商品类型') }}：{{ queryParam.goodsTypeList.join(', ') }}
            </div>
            <div v-if="queryParam.labelList">{{ $t('标签') }}：{{ queryParam.labelList }}</div>
            <div v-if="!hasAnyFilter">{{ $t('无筛选条件（将修改所有商品）') }}</div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

  </page-header-wrapper>
</template>

<script>
import { batchOn, batchOff, delGoods, pageGoods, batchCopy } from '@/api/goods/goods'
import { allLabel } from '@/api/goods/label'
import CustomDictTag from '@/components/DictCustomTag'
import UpdateSkuStock from './modules/UpdateSkuStock'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { listCategory } from '@/api/goods/category'
import { allBrand } from '@/api/goods/brand'
import bus from '@/utils/bus'
import moment from 'moment'
import store from '@/store'
import { getConfigKey } from '@/api/system/config'
import ImportExcel from '@/views/goods/goods/modules/ImportExcel.vue'

export default {
  name: 'Goods',
  components: {
    ImportExcel,
    CustomDictTag,
    UpdateSkuStock
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      categoryList: [{ id: '0', categoryName: '' }],
      cateOptions: [],
      brandList: [],
      labelList: [],
      clubList: [],
      starList: [],
      pagetype: 1,  // 1商品列表 2新增编辑商品页面
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 批量改价相关
      batchPriceModalVisible: false,
      batchPriceLoading: false,
      batchPriceForm: {
        price: null
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        goodsCode: undefined,
        goodsName: undefined,
        goodsSku: undefined,
        goodsType: undefined,
        goodsTypeList: [],
        saleEndDate: undefined,
        saleEndTime: undefined,
        categoryId: undefined,
        shopId: undefined,
        isShowApp: undefined,
        shopCategoryId: undefined,
        brandId: undefined,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        isHavePoster: undefined,
        status: undefined,
        starId: undefined,
        clubId: undefined,
        starName: undefined,
        labelList: undefined,
        prodArea: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          width: 160,
          fixed: 'left'
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 300,
          fixed: 'left'
        },

        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          width: '80px',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: this.$t('商品分类'),
          dataIndex: 'categoryId',
          width: '80px',
          scopedSlots: { customRender: 'categoryId' }
        },

        {
          title: this.$t('商品类型'),
          dataIndex: 'goodsType',
          width: '120px',
          scopedSlots: { customRender: 'goodsType' },
          align: 'center'
        },
        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          width: '100px',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('市场价'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'marketPrice',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('商品售价'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'price',
          width: '80px'
        },
        {
          title: this.$t('已售数量'),
          dataIndex: 'realSalesNum',
          width: '80px'
        },
        {
          title: this.$t('虚拟销量'),
          dataIndex: 'virtualSalesNum',
          width: '80px'
        },
        {
          title: this.$t('库存'),
          dataIndex: 'stock',
          scopedSlots: { customRender: 'stock' },
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          width: '80px'
        },
        //是否赠品
        {
          title: this.$t('是否赠品'),
          dataIndex: 'isGift',
          width: '80px',
          scopedSlots: { customRender: 'isGift' }
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width: 150,
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getBrandList()
    this.getCategoryList()
    this.getLabelList()
    /**编辑页面接收到更新的数据 */
    bus.$on('updateGoodsList', () => {
      this.getList()
    })
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    $route: 'getRouteList'
  },
  mounted() {
    this.getRouteList()
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    hasPermission(val) {
      const allPermission = '*:*:*'
      const permissions = store.getters && store.getters.permissions
      const hasPermissions = permissions.some(permission => {
        return allPermission === permission || permissions.includes(permission)
      })
      return hasPermissions
    },
    getRouteList() {
      let params = this.$route.params
      if (params) {
        for (let key in params) {
          this.queryParam[key] = params[key]
        }
      }
      this.getList()
    },

    /** 查询商品列表 */
    getList() {
      this.loading = true
      pageGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /*页面初始化时获取分类类别*/
    getCategoryList() {
      listCategory().then(response => {
        this.categoryList = response.data
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },

    /*页面初始化时获取标签类别*/
    getLabelList() {
      allLabel().then(response => {
        this.labelList = response.data
      })
    },

    getCategoryNameById(id) {
      if (!id) {
        return ''
      }
      let cateInfo = this.categoryList.find(e => e.id === id)
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return ''
      }
    },

    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    getBrandNameById(id) {
      if (!id) {
        return ''
      }
      let brandInfo = this.brandList.find(e => e.id === id)
      if (brandInfo) {
        return brandInfo.name
      } else {
        return ''
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        goodsCode: undefined,
        goodsName: undefined,
        goodsSku: undefined,
        goodsType: undefined,
        goodsTypeList: [],
        categoryId: undefined,
        saleEndDate: undefined,
        saleEndTime: undefined,
        shopId: undefined,
        shopCategoryId: undefined,
        isShowApp: undefined,
        brandId: undefined,
        isRecommend: undefined,
        isNew: undefined,
        isHavePoster: undefined,
        isRestriction: undefined,
        status: undefined,
        starId: undefined,
        clubId: undefined,
        starName: undefined,
        prodArea: undefined,
        labelList: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    // 批量改价 - 打开弹窗
    handleBatchUpdatePrice() {
      this.batchPriceForm.price = null
      this.batchPriceModalVisible = true
    },
    // 批量改价 - 取消
    handleBatchPriceCancel() {
      this.batchPriceModalVisible = false
      this.batchPriceForm.price = null
    },
    // 批量改价 - 确认
    handleBatchPriceConfirm() {
      if (!this.batchPriceForm.price || this.batchPriceForm.price <= 0) {
        this.$message.warning(this.$t('请输入有效的价格'))
        return
      }

      const self = this

      // 构建请求参数：筛选条件 + 新价格
      const params = {
        goodsName: self.queryParam.goodsName,
        id: self.queryParam.id,
        categoryId: self.queryParam.categoryId,
        status: self.queryParam.status,
        isRecommend: self.queryParam.isRecommend,
        isNew: self.queryParam.isNew,
        isRestriction: self.queryParam.isRestriction,
        isShowApp: self.queryParam.isShowApp,
        goodsTypeList: self.queryParam.goodsTypeList,
        labelList: self.queryParam.labelList,
        price: self.batchPriceForm.price
      }

      console.log('批量改价参数：', params)

      // TODO: 调用后端接口
      import('@/api/goods/goods').then(module => {
        module.batchUpdatePrice(params).then(() => {
          self.$message.success(self.$t('批量改价成功'))
          self.handleBatchPriceCancel()
          self.getList()
        }).catch(() => {
          self.$message.error(self.$t('批量改价失败'))
        })
      })

      // this.$message.info('功能待实现，参数已打印到控制台')
      this.handleBatchPriceCancel()
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    onStarSelect(value) {
      this.queryParam.starId = value
    },
    handleStarSearch(value) {
      if (value === undefined) {
        return
      }
      if (value === '') {
        return
      }
      listStar({ 'starName': value }).then(response => {
        this.starList = response.data
      })
    },
    handleStarChange(value) {
      this.queryParam.starId = value
      //getStarList(value, data => (this.starList = data));
    },

    onClubSelect(value) {
      this.queryParam.clubId = value
    },
    handleClubSearch(value) {
      if (value === undefined) {
        return
      }
      if (value === '') {
        return
      }
      listClub({ 'clubName': value }).then(response => {
        this.clubList = response.data
      })
    },
    handleClubChange(value) {
      this.queryParam.clubId = value
      //getStarList(value, data => (this.starList = data));
    },

    onStatusChange(record) {
      //商品快捷上下架
      let data = { 'idList': [record.id] }
      if (record.status === 1) {
        batchOn(data).then(() => {
          this.getList()
          this.$message.success(
            this.$t('上架成功'),
            3
          )
        })
      } else if (record.status === 0) {
        batchOff(data).then(() => {
          this.getList()
          this.$message.success(
            this.$t('下架成功'),
            3
          )
        })
      }
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.$router.push({
        path: 'goodsForm',
        query:
          {
            id: undefined
          }
      })
    },

    handleJumpStar(starId) {
      this.$router.push({
        name: 'Star',
        params:
          {
            id: starId
          }
      })
    },
    updateSkuStock(goodsId, goodsType) {
      this.$refs.updateSkuStock.show(goodsId, goodsType)
    },

    openRank(record) {
      //查看排行
      this.$router.push({
        path: 'goodsOrderRank',
        query:
          {
            goodsId: record.id,
            goodsType: record.goodsType
          }
      })
    },

    handlePreviewGoods(row) {
      getConfigKey('app.domain').then(response => {
        let url = response.data + '/pages/goods/goodsdetail/goods-detail/yulan?sku_id=0&goods_id=' + row.id
        window.open(url, '_blank')
      })
    },
    handleCopyGoodsLink(row) {
      getConfigKey('app.domain').then(response => {
        let url = response.data + '/pages/goods/goodsdetail/goods-detail/yulan?sku_id=0&goods_id=' + row.id
        navigator.clipboard.writeText(url)
        this.$message.success('链接已复制至粘贴板', 3)
      })
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {
      this.$router.push({
        path: 'goodsForm',
        query:
          {
            id: row.id
          }
      })
    },
    handleCopy(row) {
      this.$router.push({
        path: 'goodsForm',
        query:
          {
            id: row.id,
            'copy': true
          }
      })
    },
    handleBatchCopy(row) {
      var that = this
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      let ids = this.ids
      this.$confirm({
        title: this.$t('确认复制'),
        onOk() {
          let data = { 'idList': ids }
          return batchCopy(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('复制成功'),
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delGoods(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('删除成功'),
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 批量上架操作 */
    handleOn(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      let data = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认上架'),
        onOk() {
          return batchOn(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('上架成功'),
                3
              )
            })
        },
        onCancel() {
          //取消清空ids列表
          that.ids = []
        }
      })
    },

    /** 批量下架操作 */
    handleOff(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      let data = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认下架'),
        onOk() {
          return batchOff(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('下架成功'),
                3
              )
            })
        },
        onCancel() {
          //取消清空ids列表
          that.ids = []
        }
      })
    },

    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('goods/goods/export',
            that.queryParam
            , `商品_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleSelectExport() {
      var that = this
      let queryParam = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk() {
          that.download('goods/goods/export', queryParam, `商品_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        },
        onCancel() {
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        }
      })
    },
    handleImportGoods() {
      this.$refs.importExcelRef.importExcelHandleOpen()
    }
  }
}
</script>
